module.exports = __webpack_public_path__ + "static/img/img(43).b0fba0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(43).png
// module id = mpKs
// module chunks = 1